import React from 'react';
import { Modal, Typography } from 'antd';
import ParentList from '../components/ParentList';
import ChildList from '../components/ChildList';

const title = 'Помещение находится в связке';

export const createConfirm = ({ onOk, relation, currentHouseId, isParent }) => {
  Modal.confirm({
    title,
    content: (
      <Content
        isParent={isParent}
        relation={relation}
        currentHouseId={currentHouseId}
      />
    ),
    centered: true,
    onCancel: () => {},
    onOk,
  });
};

function Content({ relation, isParent, currentHouseId }) {
  return (
    <div>
      {isParent ? (
        <ParentList roomData={relation} />
      ) : (
        <ChildList roomData={relation} currentHouseId={currentHouseId} />
      )}
      <Typography.Paragraph>Продолжить?</Typography.Paragraph>
    </div>
  );
}
